import { useEffect, useRef, useState } from 'react';
import MyNavbar from '../Navbar/MyNavbar';
import Sidebar from '../Sidebar/Sidebar';
import './AdminLayout.css';

const MOBILE_QUERY = '(max-width: 1199px)';

function AdminLayout({ children }) {
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  const desktopPreference = useRef(true);
  const [sidebarOpen, setSidebarOpen] = useState(() => !window.matchMedia(MOBILE_QUERY).matches);

  const closeSidebar = () => {
    setSidebarOpen(false);
    if (!mobile) desktopPreference.current = false;
  };

  const toggleSidebar = () => {
    setSidebarOpen((current) => {
      const next = !current;
      if (!mobile) desktopPreference.current = next;
      return next;
    });
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const onBreakpointChange = (event) => {
      const nextMobile = event.matches;
      setMobile(nextMobile);
      setSidebarOpen(nextMobile ? false : desktopPreference.current);
    };
    mediaQuery.addEventListener('change', onBreakpointChange);
    return () => mediaQuery.removeEventListener('change', onBreakpointChange);
  }, []);

  useEffect(() => {
    const onEscape = (event) => {
      if (event.key === 'Escape' && sidebarOpen) {
        setSidebarOpen(false);
        if (!mobile) desktopPreference.current = false;
      }
    };
    window.addEventListener('keydown', onEscape);
    return () => window.removeEventListener('keydown', onEscape);
  }, [sidebarOpen, mobile]);

  useEffect(() => {
    document.body.classList.toggle('admin-scroll-lock', mobile && sidebarOpen);
    return () => document.body.classList.remove('admin-scroll-lock');
  }, [mobile, sidebarOpen]);

  return <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${mobile ? 'sidebar-mobile' : 'sidebar-desktop'}`}>
    <MyNavbar sidebarOpen={sidebarOpen} onToggleSidebar={toggleSidebar} mobile={mobile} />
    <Sidebar open={sidebarOpen} mobile={mobile} onNavigate={() => mobile && closeSidebar()} />
    {mobile && sidebarOpen && <button type="button" className="admin-sidebar-overlay" aria-label="Cerrar menú" onClick={closeSidebar} />}
    <div className="admin-content">{children}</div>
  </div>;
}

export default AdminLayout;
